import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import { Page } from './structure/Page';

ReactDOM.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>,
  document.getElementById('root'),
);
